module.exports = __webpack_public_path__ + "img/SEJ enventos_sede virtual.e14d1036.svg";